/* eslint-disable max-len */

import { motion } from 'framer-motion';
import React, { forwardRef } from 'react';

import { cn } from '../utils';

const Card = forwardRef(
  ({ children, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'shadow-md dark:shadow-primary/25 hover:shadow-xl transition-shadow rounded-xl bg-white dark:bg-black border border-black/10 dark:border-white/25',
        className,
      )}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </div>
  ),
);

export const AnimatedCard = motion(Card);
AnimatedCard.displayName = 'AnimatedCard';
Card.displayName = 'Card';
export default Card;
